import { GetComplianceActionsSchemaContract } from 'schemas/GetComplianceActionsSchema';
import {
  actionStatusesMap,
  complianceActionsMap,
  payrollSummaryDescriptionMap,
} from 'components/RunPayroll/ComplianceActions/data';
import { ComplianceAction } from 'components/RunPayroll/ComplianceActions/contexts/ComplianceActionsContext';

export const isCompliancePaymentInProgress = ({
  actionsApiResponse,
}: {
  actionsApiResponse?: GetComplianceActionsSchemaContract['actions'];
}) => {
  let isAnyActionInProgress = false;
  if (actionsApiResponse) {
    const actionNames = Object.keys(actionsApiResponse) as ComplianceAction[];

    for (const actionName of actionNames) {
      if (actionName === complianceActionsMap.payPt) {
        const action = actionsApiResponse[actionName];
        const subActionNames = Object.keys(action);
        const inProgressSubActions = subActionNames.find(
          (subActionName) => action[subActionName].status === actionStatusesMap.inProgress,
        );
        if (inProgressSubActions) {
          isAnyActionInProgress = true;
          break;
        }
      }
      const action = actionsApiResponse[actionName];
      if (action.status === actionStatusesMap.processing) {
        isAnyActionInProgress = true;
        break;
      }
    }
  }
  return isAnyActionInProgress;
};

export const getKAPTWindowNotOpenMessage = (payrollMonth: string, kaPtWindowOpenDay: number) => {
  const [year, month] = payrollMonth.split('-').map(Number);
  const currentPayroll = new Date(year, month - 1, 1).toLocaleString('default', { month: 'long' });

  const windowOpenMonth = new Date(year, month, kaPtWindowOpenDay).toLocaleString('default', { month: 'long' });

  return `As per Karnataka PT rules, PT payment for ${currentPayroll} payroll month will be available from the ${kaPtWindowOpenDay} ${windowOpenMonth}. Please retry after that date.`;
};

/**
 * Summary copy for the run-payroll step.
 *
 * `partially_executed` is reached whenever some employees were not paid — skipped
 * ones, or ones that were never finalized — so it must not read as a clean
 * success. The counts are already on the action, so the copy states them.
 */
export const getPayrollSummaryDescription = (
  action: GetComplianceActionsSchemaContract['actions']['run-payroll'],
) => {
  if (action.status !== actionStatusesMap.partiallyExecuted) {
    return payrollSummaryDescriptionMap[action.status];
  }

  const paid = action.meta.payroll_executed_employees ?? 0;
  const total = action.meta.payroll_executed_employees_total ?? 0;
  const unpaid = action.meta.payroll_executed_employees_pending ?? 0;

  if (!total || !unpaid) {
    return payrollSummaryDescriptionMap[actionStatusesMap.partiallyExecuted];
  }

  return `Payroll has been executed for ${paid} of ${total} employees. ${unpaid} ${
    unpaid === 1 ? 'employee was' : 'employees were'
  } not paid this month.`;
};
